import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { FindLoad, FindSuccessItem, renderGoalTypes, useModal } from 'utils';
import { CreateChancel, Input } from 'components';
import { baselineActions, httpRequestsOnSuccessActions } from 'store';

const ACTION_TYPE = 'EDIT_BASELINE';

export const EditBaseline = ({ currentItem, target, afterSuccess }) => {
    const goalById = useSelector((state) => state.goals.goalById);
    const dispatch = useDispatch();
    const { close } = useModal();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({});

    useEffect(() => {
        if (currentItem) {
            reset({
                name: currentItem?.name,
            });
        }
    }, [currentItem]);

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            if (afterSuccess) {
                afterSuccess();
            }
        }
    }, [success]);

    const handleCreate = (data) => {
        dispatch(
            baselineActions.editBaseline(currentItem?.id, {
                ...data,
                success: currentItem?.status,
            })
        );
    };

    return (
        <div style={{ width: 700 }}>
            <div className="space-between" style={{ marginTop: 8 }}>
                <p className="modal-header-title">{'Edit Baseline'}</p>
                <div className="correct-goal-box">{renderGoalTypes(goalById?.dataType)}</div>
            </div>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <Input
                        type="text"
                        name="name"
                        label="Baseline Name*"
                        variant="outlined"
                        control={control}
                        rules={{
                            required: 'Baseline Name is required.',
                        }}
                    />
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={currentItem ? 'Save' : 'Add'}
                    chancel="Cancel"
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
